export default {"src":"/_next/static/media/ftIcon1.022b52db.svg","height":66,"width":68};